import React, { useState } from 'react'
import { Button, Card, Link, Row, Text } from "@nextui-org/react";


export function HelpMenu() {
    const [open, setOpen] = useState(false);

    const onPress = (() => {
        if (open) {
            setOpen(false)
        } else {
            setOpen(true)
        }
        console.log(open);
    });

    if (!open) {
        return (
            <>
                <Button
                    size="xs"
                    auto
                    color="grey"
                    css={{ zIndex: "0" }}
                    onPress={onPress}
                >
                    Can't find your address?
                </Button>
            </>
        )
    } else if (open) {
        return (
            <Card css={{ width: 'fit-content', padding: '10px' }}>
                <Card.Header css={{ padding: '0px' }}>
                    <Row justify="center">
                        <Text>An address is required to proceed. You may be able to</Text>
                    </Row>
                </Card.Header>
                <Card.Body css={{ padding: '0px' }}>
                    <Text align="center">
                        <Link
                            isExternal
                            showAnchorIcon
                            href="https://www.claytoncountyga.gov/wp-content/uploads/2022/06/Address-Assignment-Application.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >request an address assignment or modification</Link>.
                    </Text>
                </Card.Body>
                <Card.Footer css={{ padding: '0px' }}>
                    <Row justify="center">
                        <br />
                        <Button auto light size="sm" color="error" onPress={onPress}>
                            Close
                        </Button>
                    </Row>
                </Card.Footer>
            </Card>
        )

    }

}